import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CurrentUserService } from '@core/services';
import { MixpanelService } from '@core/services/mixpanel.service';
import { UserGroupService } from '@core/services/user-group.service';
import { BreadcrumbsComponent } from '@layout/components/breadcrumbs.component';
import { FooterComponent } from '@layout/components/footer/footer.component';
import { HeaderComponent } from '@layout/components/header/header.component';
import { MobileMenuComponent } from '@layout/components/mobile-menu/mobile-menu.component';
import { SidebarComponent } from '@layout/components/sidebar/sidebar.component';
import { SidebarService } from '@layout/core/services';
import { ErrorPageComponent, LoaderComponent, UnauthorizedPageComponent } from '@shared/components';
import { ToasterPositionEnum } from '@shared/enums';
import { CurrentUser } from '@shared/interfaces';
import { MenuItem } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { AnnouncementModalComponent } from './features/dashboard/_components';
import { DeleteDraftModalComponent } from './shared/components/orders-and-retests/delete-draft-modal/delete-draft-modal.component';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [
        NgClass,
        RouterOutlet,
        ToastModule,
        DeleteDraftModalComponent,
        HeaderComponent,
        BreadcrumbsComponent,
        SidebarComponent,
        MobileMenuComponent,
        FooterComponent,
        ErrorPageComponent,
        LoaderComponent,
        UnauthorizedPageComponent,
        AnnouncementModalComponent,
    ],
})
export class AppComponent {
    isSidebarCollapsed: boolean = true;
    hasError: boolean = false;
    currentUser: CurrentUser | null = null;
    toasterPositions = ToasterPositionEnum;

    items: MenuItem[] | undefined;
    window = window;

    isUserLoading = true;
    isActiveGroupLoading = true;

    constructor(
        private sidebarService: SidebarService,
        private currentUserService: CurrentUserService,
        private mixpanel: MixpanelService,
        private userGroupService: UserGroupService
    ) {
        this.mixpanel.init();

        this.sidebarService.isCollapsed$.subscribe((isCollapsed: boolean) => {
            this.isSidebarCollapsed = isCollapsed;
        });

        this.currentUserService.currentUser$.subscribe(user => {
            this.currentUser = user;
            if (user) {
                this.isUserLoading = false;
                this.hasError = false;
            }
        });

        this.currentUserService.currentUserError$.subscribe(hasError => {
            this.currentUser = null;
            this.isUserLoading = false;
            this.hasError = hasError;
        });

        this.userGroupService.groupsError$.subscribe(() => {
            this.isActiveGroupLoading = false;
            this.hasError = true;
        });

        this.userGroupService.currentGroup$.subscribe(group => {
            this.isActiveGroupLoading = !group;
        });
    }
}
